/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Name_LabelInputs */



/**
* | output |
* | --- |
* | "Style Guide Name" |
*
* @param {Style_Guide_Manager_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_name_label = /** @type {((inputs?: Style_Guide_Manager_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom du guide de style")
	if (locale === "de") return /** @type {LocalizedString} */ ("Name des Styleguides")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome della guida di stile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Название руководства по стилю")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre de la guía de estilo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("风格指南名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイルガイド名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शैली मार्गदर्शिका का नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nome do guia de estilo")
	return /** @type {LocalizedString} */ ("Style Guide Name")
});